var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:_vm.classNames,on:{"click":_vm.onClickMethod}},'div',_vm.$attrs,false),[(_vm.hasMask)?_c('div',{staticClass:"PopoutWrapper__mask"}):_vm._e(),_c('div',{staticClass:"PopoutWrapper__container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }